// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.
var _isProduction = false;
var _isSpecial = true;
var awsmobile = {};
if (_isProduction) {
	awsmobile = {
		aws_project_region: 'af-south-1',
		aws_cognito_identity_pool_id: 'eu-west-1:6afefc5d-ff90-48e2-afc6-5e21b11c0a9f',
		aws_cognito_region: 'eu-west-1',
		aws_user_pools_id: 'eu-west-1_m9cWgl2X9',
		// "aws_user_pools_web_client_id": "g7pmm3ca02kpma5nlbsim3l2",
		aws_user_pools_web_client_id: '4ckasjcga10a00dkg3iljtofob',
		oauth: {},
	};
} else if (_isSpecial) {
	awsmobile = {
		aws_project_region: 'eu-west-1',
		aws_cognito_identity_pool_id: 'eu-west-1:9f6f4852-8b14-45b9-92ca-a61376b9bad0',
		aws_cognito_region: 'eu-west-1',
		aws_user_pools_id: 'eu-west-1_24y1tySD7',
		aws_user_pools_web_client_id: '2sf1jffnjf7keon6tpr7sn9qim',
		oauth: {},
	};
} else {
	awsmobile = {
		aws_project_region: 'eu-west-1',
		aws_cognito_identity_pool_id: 'eu-west-1:22f38a6e-ffd2-4765-858f-3c08a30afb35',
		aws_cognito_region: 'eu-west-1',
		aws_user_pools_id: 'eu-west-1_CeUcmb0Rj',
		aws_user_pools_web_client_id: '2qk8pnbe9k1bdfm04prtdo32ke',
		oauth: {},
	};
}

export default awsmobile;
